import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getUpcomingPhaseItemsIds,
  getUpcomingAssignmentsIds,
} from '../../getters/entities/taskIds'
import { NormalizedTask } from '../types'
import { selectNormalizedTasks } from './normalizedTasks'

const selectUpcomingAssignmentIds = createSelector(
  [getUpcomingAssignmentsIds],
  (upcomingAssignmentIds) => upcomingAssignmentIds || []
)

const selectUpcomingPhaseItemIds = createSelector(
  [getUpcomingPhaseItemsIds],
  (upcomingPhaseItemIds) => upcomingPhaseItemIds || []
)

export const selectUpcomingTasks = createSelector(
  [
    selectNormalizedTasks,
    selectUpcomingAssignmentIds,
    selectUpcomingPhaseItemIds,
  ],
  (normalizedTasks, upcomingAssignmentIds, upcomingPhaseItemIds) => {
    const phaseItems = upcomingPhaseItemIds.map((id) =>
      normalizedTasks.find(
        (task) => task.id === id && task.entityType === 'phase_item'
      )
    )

    const assignments = upcomingAssignmentIds.map((id) =>
      normalizedTasks.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (task): task is NormalizedTask => task !== undefined
      )
    )
  }
)
